// extracted by mini-css-extract-plugin
export default {"productGroupDrawerRoot":"productGroupDrawerRoot___hVzOj","productGroupThumbnailUpload":"productGroupThumbnailUpload___YMlon","deleteButton":"deleteButton___t4kSS"};